import { getFirstCorrectImage } from "./global";
import { PROMOTION__CRITERIA } from "../constants/promotion";

export const mechanicDataMapper = (mechanicDetails) => {
  return {
    type: mechanicDetails.type,
    balance: mechanicDetails.balance,
    isWeeklyBonusEnabled: mechanicDetails.isWeeklyBonusEnabled,
    isPricesBlured: mechanicDetails.isPricesBlured,
    branches: mechanicDetails.branchList.map((branch) => ({
      name: branch.name,
      id: branch.id,
      isDefault: branch.isDefault,
    })),
  };
};

export const skuCategoriesMapper = (categories) => {
  return categories.map((category) => ({
    id: category.id,
    name: category.name,
    image: category.imageUrl,
    subCategories: category.skuSubCategoryList?.map((subCategory) => ({
      id: subCategory.id,
      name: subCategory.name,
    })),
  }));
};

export const skuDetailsMapper = (skuDetails) => {
  return {
    details: {
      name: skuDetails.name,
      brandName: skuDetails.skuBrand,
      categoryName: skuDetails.skuCategoryName,
      categoryId: skuDetails.skuCategoryId,
      subcategoryName: skuDetails.skuSubCategoryName,
      subcategoryId: skuDetails.skuSubCategoryId,
      images: skuDetails.images,
      availableQuantity: skuDetails.quantity,
      price: skuDetails.price,
      isIncludedInBundle: skuDetails.isIncludedInBundle,
      isCartRuleApplied: skuDetails.isCartRuleApplied,
    },
    cars: skuDetails.carList.map((car) => ({
      brandId: car.brandId,
      brandName: car.brandName,
      brandImage: car.brandImageUrl,
      models: car.modelList.map((model) => ({
        modelId: model.modelId,
        modelName: model.modelName,
        startYear: model.startYear,
        endYear: model.endYear,
      })),
    })),
  };
};

export const bundleDetailsMapper = (bundle) => {
  return {
    details: {
      id: bundle.id,
      name: bundle.name,
      availableQuantity: bundle.availableQuantity,
      images: bundle.skuList.map((sku) => getFirstCorrectImage(sku.images)),
      price: bundle.priceBeforeDiscount - bundle.discount,
    },
    bundleSkus: bundle.skuList.map((sku) => ({
      id: sku.skuId,
      name: sku.name,
      brandName: sku.brandName,
      quantity: sku.quantity,
    })),
  };
};

export const cartDataMapper = (skuList, bundleList, cartSize) => {
  return {
    skus: skuList.map((sku) => ({
      id: sku.skuId,
      quantity: sku.quantity,
    })),
    bundles: bundleList.map((bundle) => {
      return {
        id: bundle.id,
        quantity: bundle.requestedQuantity,
        canAddMore: bundle.canAddMore,
        skus: bundle.skuList.map((sku) => ({
          id: sku.skuId,
          quantity: sku.quantity,
        })),
      };
    }),
    cartSize,
  };
};

export const skuBrandsMapper = (skuBrands) => {
  return skuBrands.map((skuBrand) => ({
    id: skuBrand.id,
    name: skuBrand.brandName,
    imageUrl: skuBrand.brandImage,
  }));
};

export const carBrandsMapper = (carBrands) => {
  return carBrands.map((carBrand) => ({
    id: carBrand.id,
    name: carBrand.brandName,
    englishName: carBrand.brandNameEn || "",
    imageUrl: carBrand.imageUrl,
  }));
};

export const carModelsMapper = (carModels) => {
  return carModels.map((carModel) => ({
    id: carModel.id,
    name: carModel.modelName,
    imageUrl: carModel.imageUrl,
  }));
};

export const carTransmissionAndCCMapper = (carTransmissionsAndCC) => {
  return carTransmissionsAndCC.map((carTransmissionAndCC) => ({
    name: `${carTransmissionAndCC.transmission}-${carTransmissionAndCC.cc}`,
  }));
};

export const carYearListMapper = (carYearList) => {
  return carYearList.map((carYear) => ({
    name: `${carYear.startYear}-${carYear.endYear}`,
  }));
};

export const bundleSkusMapper = (bundleSkus) => {
  return bundleSkus.map((bundleSku) => ({
    id: bundleSku.skuId,
    quantity: bundleSku.quantity,
  }));
};

export const promotionsMapper = (promotions) => {
  const availableCriterias = Object.values(PROMOTION__CRITERIA);
  return promotions.filter((promotion) =>
    promotion.criteriaProgressList.some((criteria) =>
      availableCriterias.includes(criteria.name)
    )
  );
};
